angular.module("app").component("studentStaffLoginComponent", {
  templateUrl: "app/components/student-staff-login/student-staff-login.tmpl.html",
  controller: function (authService, $state, localStorageService, $http, appConfig) {
    const self = this;
    self.email = "";
    self.password = "";
    self.isRemembered = false;
    self.error = false;
    self.showPw = false;
    self.schoolList = [];
    self.schoolId = null;
    self.ssoError = "";
    self.ssoBusy = false;
    const products = { courses: {}, reports: {}, teaching_materials: {} };
    localStorageService.set("products", products);

    // Schools with SSO set up in admin (saml_schools)
    $http.get(appConfig.dashboardServiceUrl + "api/enterprise/schools/saml").then((res) => {
      self.schoolList = (res.data && res.data.schools) || [];
      if (self.schoolList.length === 1) self.schoolId = self.schoolList[0].id;
    });

    self.ssoLogin = () => {
      if (!self.schoolId) {
        self.ssoError = "Choose your school or company first.";
        return;
      }
      self.ssoBusy = true;
      // Read back on /single-sign-on/t/:token after the identity provider returns
      localStorageService.set("ssoRemember", !!self.isRemembered);
      authService
        .schoolSSOLogin({ school_id: self.schoolId })
        .then((res) => {
          if (res && res.url) {
            window.location.href = res.url;
          } else {
            self.ssoBusy = false;
            self.ssoError = (res && res.msg) || "SSO isn't available for this school right now.";
          }
        })
        .catch((err) => {
          self.ssoBusy = false;
          self.ssoError = (err && err.data && err.data.msg) || "SSO isn't available for this school right now.";
        });
    };

    self.login = () => {
      self.error = false;
      authService
        .schoolEnterpriseLogin(self.email, self.password, self.isRemembered)
        .then(function (data) {
          if (data && data.success === true) {
            $state.go("landing-page");
          } else {
            self.error = true;
          }
        })
        .catch(() => {
          self.error = true;
        });
    };
  },
});
